export default __webpack_public_path__ + "static/media/behance.46e439cb.svg";